import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';

import FacialIcon from '@mui/icons-material/Face';
import HairColorIcon from '@mui/icons-material/ColorLens';
import ManicureIcon from '@mui/icons-material/LocalFlorist';
import PedicureIcon from '@mui/icons-material/Spa';
import WaxingIcon from '@mui/icons-material/Waves';
import SpaIcon from '@mui/icons-material/Spa';
import HairstyleIcon from '@mui/icons-material/Brush';
import MakeupIcon from '@mui/icons-material/Face';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function FetchEmployee() {
  const [activitiesData, setActivitiesData] = useState([]);
  const db = getFirestore();

  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, 'activities_selected'));
      const data = querySnapshot.docs.map(doc => {
        const docData = doc.data();
        return {
          ...docData,
          date: docData.date ? docData.date.toDate() : new Date(), // Convert to Date object
        };
      });
      
      // Sort activitiesData by date (most recent first)
      data.sort((a, b) => b.date - a.date);
      
      setActivitiesData(data);
    };

    fetchData();
  }, [db]);

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ color: '#1976d2', textAlign: 'center', marginBottom: 4 }}>
        Employee Activities Log
      </Typography>

      <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell>Activity</TableCell>
              <TableCell>Remarks</TableCell>
              <TableCell>Time Spent (hours)</TableCell>
              <TableCell>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {activitiesData.map((activity, index) => (
              <Row key={index} row={activity} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

function Row(props) {
  const { row } = props;
  const formattedDate = row.date ? row.date.toLocaleDateString() : 'N/A'; // Handle case where date may be undefined

  const getIconForActivity = (item) => {
    switch (item) {
      case "Haircut": return <HairColorIcon sx={{ color: '#ef5350' }} />;
      case "Facial": return <FacialIcon sx={{ color: '#ab47bc' }} />;
      case "Hair Colouring": return <HairColorIcon sx={{ color: '#5c6bc0' }} />;
      case "Manicure": return <ManicureIcon sx={{ color: '#26a69a' }} />;
      case "Pedicure": return <PedicureIcon sx={{ color: '#8d6e63' }} />;
      case "Waxing": return <WaxingIcon sx={{ color: '#ffca28' }} />;
      case "Massage": return <SpaIcon sx={{ color: '#66bb6a' }} />;
      case "Hairstyling": return <HairstyleIcon sx={{ color: '#ffa726' }} />;
      case "MakeUp": return <MakeupIcon sx={{ color: '#ec407a' }} />;
      default: return null;
    }
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell component="th" scope="row">
          {row.checkedItems.map((item, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
              <Avatar sx={{ bgcolor: 'transparent', marginRight: 1 }}>
                {getIconForActivity(item)}
              </Avatar>
              <Typography variant="body1">{item}</Typography>
            </Box>
          ))}
        </TableCell>
        <TableCell>
          <Typography variant="body1">{row.remarks}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant="body1">
            <AccessTimeIcon sx={{ verticalAlign: 'middle', marginRight: 1 }} />
            {row.timeSpent}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="body1">{formattedDate}</Typography>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default FetchEmployee;